import { render, staticRenderFns } from "./EditParticipantsDetails.vue?vue&type=template&id=10232a9d"
import script from "./EditParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./EditParticipantsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports